import { useEffect, useRef } from 'react';
import { motion, useAnimationFrame } from 'framer-motion';

const marqueeText = 'Premium Quality • Sustainable Farming • Elite Breeding • Trusted Excellence • ';

export const Marquee = () => {
  const marqueeRef = useRef(null);
  const xPercent = useRef(0);

  useAnimationFrame(() => {
    if (marqueeRef.current) {
      xPercent.current -= 0.05;
      if (xPercent.current <= -100) {
        xPercent.current = 0;
      }
      marqueeRef.current.style.transform = `translateX(${xPercent.current}%)`;
    }
  });

  return (
    <div className="py-12 bg-farm-gold overflow-hidden">
      <div
        ref={marqueeRef}
        className="flex whitespace-nowrap"
        style={{ willChange: 'transform' }}
      >
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex items-center">
            {marqueeText.split('•').map((text, idx) => (
              <div key={idx} className="flex items-center">
                <span className="text-5xl md:text-7xl font-serif font-bold text-farm-dark px-8">
                  {text.trim()}
                </span>
                {idx < marqueeText.split('•').length - 1 && (
                  <span className="text-farm-dark text-2xl">•</span>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};